module.exports = require('keen-core/lib/utils/extend');



//////////////////
// WEBPACK FOOTER
// ./~/keen-tracking/lib/utils/extend.js
// module id = 1962
// module chunks = 0